module.exports = __webpack_public_path__ + "static/media/caixa.0134d688.svg";